import * as Sentry from '@sentry/vue'

const sentryConfig = {
  followUser (userid, slink) {
    Sentry.getCurrentScope().setUser({
      school: slink,
      id: userid
    })
  },
  addBreadcrumb (breakcrumb) {
    Sentry.addBreadcrumb(breakcrumb)
  },
  throwError (error) {
    Sentry.captureMessage(error)
  }
}

export default sentryConfig
